/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { openDashboardDialog } from '@actions/dashboard-actions';
import { isWorkflowEnabled } from '@constants/config';
import * as dialog from '@constants/dialogs';
import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import StartCycleDialog from '@shared/dialogs/start-cycle-dialog';
import { canAccessWorkflow } from '@utils/permission-utils';
import Details from './details';
import CycleList from './cycle-list';
import EntityList from './entity-list';
import Metrics from './metrics';
import './drawer.scss';

const Drawer = ({ activeTab }) => {
  const dispatch = useDispatch();

  // Redux state
  const group = useSelector(state => state.groups.edit.group);
  const isTrayEmpty = useSelector(state => isEmpty(state.map.trays));

  const getStyles = () => {
    if (isTrayEmpty) {
      return {};
    }
    return {
      opacity: 0.4,
      pointerEvents: 'none',
      userSelect: 'none'
    };
  };

  const startCycle = useCallback(() => {
    if (!group) {
      return;
    }
    const params = { groupId: group.id, reloadGroup: true };
    dispatch(openDashboardDialog(dialog.START_CYCLE, params));
  }, [group, dispatch]);

  const canStartWorkflow = canAccessWorkflow('cycle', 'add');
  const renderActions = activeTab === 'cycles' && group && group.id && canStartWorkflow;

  return (
    <div styleName="group-drawer-container" style={getStyles()}>
      <div styleName="group-drawer-tabs-container">
        {activeTab === 'details' && <Details />}
        {activeTab === 'list' && <EntityList />}
        {activeTab === 'metrics' && <Metrics />}
        {activeTab === 'cycles' && <CycleList />}
      </div>
      {renderActions && (
        <div styleName="group-drawer-bottom-actions" role="presentation">
          <Button startIcon={<AddIcon />} onClick={startCycle} color="primary" fullWidth>
            START NEW
          </Button>
        </div>
      )}
      {isWorkflowEnabled() && canStartWorkflow && <StartCycleDialog />}
    </div>
  );
};

Drawer.propTypes = {
  activeTab: PropTypes.string
};

export default Drawer;
